module.exports = __webpack_public_path__ + "media/images/home/step-pickup-ceda085c3ad218e53817cd91a4a05df8.png";